import React from "react";
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import { TextType } from "../views/Admin/Program/ProgramInterfaces";

export function renderAdminEntryTextFieldDisplay(
	text: string,
	formatText: boolean,
	textType: TextType,
	wrapText: (node: React.ReactNode) => React.ReactNode,
): React.ReactNode {
	if (formatText) {
		return wrapText(parse(DOMPurify.sanitize(text)));
	}
	if (textType === TextType.Paragraph) {
		return wrapText(<span className="whitespace-pre-wrap">{text}</span>);
	}
	return wrapText(text);
}

export function renderParagraphDisplay(
	text: string,
	formatText: boolean | undefined,
	wrapText: (node: React.ReactNode) => React.ReactNode,
): React.ReactNode {
	if (formatText === false) {
		return wrapText(text);
	}
	return wrapText(parse(DOMPurify.sanitize(text)));
}
